// First-time board Shiny (foil) discovery prompt + helpers.

export const LS_SHINY_DISCOVERY_SEEN_KEY = "mmu_seen_shiny_discovery_v1";

export const SHINY_DISCOVERY_TITLE = "You've found a hidden Shiny!";

export const SHINY_DISCOVERY_MESSAGE =
    "When cards on the game board have the shiny badge, that shiny is added to your Collection.";

export function hasSeenShinyDiscovery() {
    try {
        return window.localStorage.getItem(LS_SHINY_DISCOVERY_SEEN_KEY) === "1";
    } catch {
        return false;
    }
}

export function markShinyDiscoverySeen() {
    try {
        window.localStorage.setItem(LS_SHINY_DISCOVERY_SEEN_KEY, "1");
    } catch {
        // ignore localStorage failures
    }
}

export function getBoardFoilCardIds(cards = []) {
    return (Array.isArray(cards) ? cards : [])
        .filter((card) => card && card.isFoil)
        .map((card) => card.id)
        .filter((id) => id !== null && id !== undefined && id !== "");
}

/**
 * Build collection unlocks for foil cards currently on the board.
 * Also unlocks the base card when needed so foil ownership stays coherent.
 */
export function buildBoardShinyUnlockPatch({
    cards = [],
    collectionUnlocked = [],
    collectionFoilUnlocked = [],
    normalizeId = (id) => id,
} = {}) {
    const regular = new Set(
        (Array.isArray(collectionUnlocked) ? collectionUnlocked : []).map(normalizeId)
    );
    const foil = new Set(
        (Array.isArray(collectionFoilUnlocked) ? collectionFoilUnlocked : []).map(
            normalizeId
        )
    );

    const nextRegular = [...regular];
    const nextFoil = [...foil];
    const newlyGrantedFoilIds = [];
    let unlockedBaseCount = 0;

    getBoardFoilCardIds(cards).forEach((rawId) => {
        const id = normalizeId(rawId);
        if (!foil.has(id)) {
            foil.add(id);
            nextFoil.push(id);
            newlyGrantedFoilIds.push(id);
        }
        if (!regular.has(id)) {
            regular.add(id);
            nextRegular.push(id);
            unlockedBaseCount += 1;
        }
    });

    if (!newlyGrantedFoilIds.length && unlockedBaseCount === 0) {
        return {
            granted: false,
            newlyGrantedFoilIds: [],
            unlockedBaseCount: 0,
            collectionUnlocked: Array.isArray(collectionUnlocked)
                ? collectionUnlocked
                : [],
            collectionFoilUnlocked: Array.isArray(collectionFoilUnlocked)
                ? collectionFoilUnlocked
                : [],
        };
    }

    return {
        granted: newlyGrantedFoilIds.length > 0 || unlockedBaseCount > 0,
        newlyGrantedFoilIds,
        unlockedBaseCount,
        collectionUnlocked: nextRegular,
        collectionFoilUnlocked: nextFoil,
    };
}
